var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "agent-picker" } },
    [
      _c("agent-picker-input", {
        attrs: {
          avatar: _vm.avatar,
          agent: _vm.agent,
          label: _vm.label,
          placeholder: _vm.placeholder,
          "is-disabled": _vm.isDisabled,
        },
        on: {
          click: function ($event) {
            _vm.isOpen = true
          },
        },
      }),
      _vm._v(" "),
      _c(
        "or-modal",
        {
          attrs: { "data-popup": "agent-picker", "is-open": _vm.isOpen },
          on: {
            close: function ($event) {
              _vm.isOpen = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.popupLabel ||
                          _vm.$t("hitl.modules.agent-picker.popup-title")
                      ) +
                      "\n    "
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("base-agent-list", {
            attrs: {
              avatar: _vm.avatar,
              agents: _vm.agents,
              statuses: _vm.statuses,
              "default-search-options": _vm.defaultSearchOptions,
              "rule-groups": _vm.ruleGroups,
              size: _vm.size,
              "use-search": true,
              "use-search-options": true,
              "use-default-action": true,
              "can-change-search-options": _vm.canChangeSearchOptions,
              "is-disabled": _vm.isDisabled,
            },
            on: { "item-click": _vm.onItemClick },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }